<div class="crypto-event" infinite-scroll [infiniteScrollDistance]="0.1" 
[scrollWindow]="true" (scrolled)="onScrollDown()" [infiniteScrollDisabled]="busyGettingData">
    <div class="banner-con" *ngIf="collectionDetails">
        <div class="image-banner" [ngStyle]="{'background-image':' url(' + collectionDetails.banner_image + ')'}">
        </div>
        <div class="banner-content-con">
            <div class="banner-profile-img" [ngStyle]="{'background-image':' url(' + collectionDetails.organization_details?.organization_logo
            + ')'}">
            </div>
            <div class="b-heading-con">
                <h5 class="main-head">
                    {{collectionDetails.name}}
                </h5>
                <h6 class="createdBy" *ngIf="collectionDetails.organization_details">
                    <span>Created By</span> <span
                        class="creator-name ">{{collectionDetails?.display_name}}</span>
                </h6>

                <div class="b-desc" [ngStyle]="showMore1 && {'height':'auto'}">
                    {{collectionDetails.description}}
                </div>
                <div class="show-more pointer mt-5 fs-16" (click)="showMore1 = !showMore1"
                    *ngIf="collectionDetails.description.length > 200">
                    <span *ngIf="showMore1">Show Less-</span>
                    <span *ngIf="!showMore1">Show More+</span>
                </div>
            </div>
        </div>
    </div>
    <section class="filter sticky">
        <div class="row no-gutter">
            <div class="col-4 d-flex justify-content-start align-items-center">
                <span class="fillter-btn mr-10 pointer fs-24" routerLink="/nft/collections" id="DD">
                    <span class="align-middle"><i class="fa fa-angle-left"></i></span>
                </span>
                <div class="s-con">
                    <input type="text" class="s-input" placeholder="Search by name" [(ngModel)]="searchnft"
                        (input)="getNftList('search')">
                    <i class="fa fa-search"></i>
                </div>
            </div>
            <div class="col-8 text-right d-flex justify-content-end" *ngIf="false">
                <div class="dropdown">
                    <button class=" d-btn " type="button" id="dropdownMenuButton" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        <span class="d-name">Sort By</span>
                        <span class="arrow align-middle"></span>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item">Action</a>
                        <a class="dropdown-item">Another action</a>
                        <a class="dropdown-item">Something else here</a>
                    </div>
                </div>
                <div>
                    <span class="fillter-btn ml-15 pointer" [ngClass]="{'backactive': navcolor}" id="DD"
                        (click)="toggleNava()">
                        <i class="material-icons">filter_list</i>
                    </span>
                </div>
                <!--  -->
            </div>
        </div>
    </section>
    <section class="card-Sec1">
        <div class="cards-con">
            <!--  -->
            <!-- <div *ngFor="let item of newApi ">
                <div class="cards pointer" (click)="getdata(item)">
                    <div class="imagediv" [ngStyle]="{'background-image':' url(' + item.file + ')'}">
                    </div> -->
            <ng-container *ngFor="let item of nftList; let i = index;">
                <div class="cards pointer" (click)="getdata(item)">
                    <div class="imagediv relative"
                        [ngStyle]="{'background-image':' url(' + item?.links[0].banner + ')'}"
                        *ngIf="item?.links[0]?.type == 'image'">
                        <div class="nft-count" *ngIf="item.number_of_copies_for_sale > 1 && item.saleType == 'instant' && collectionDetails.id != 'Avalanche' && collectionDetails.id != 'Polygon'">
                            <div class="fs-18">{{item.number_of_copies_for_sale}} of {{item.supply}}</div>
                        </div>
                    </div>
                    <div *ngIf="item?.links[0]?.type == 'audio' || item?.links[0]?.type == 'video'" class="relative">
                        <div class="overlay-play-btn"></div>
                        <div class="imagediv" [ngStyle]="{'background-image':' url(' + item?.links[0].thumbnail + ')'}">
                            <div class="button-on-img">
                                <i class="fa fa-play play-btn mt-20 pointer" aria-hidden="true"></i>
                            </div>
                            <div class="nft-count"
                                *ngIf="item.number_of_copies_for_sale > 1 && item.saleType == 'instant'">
                                <div class="fs-18">{{item.number_of_copies_for_sale}} of {{item.supply}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="desc-con1">
                        <div class="row no-gutters">
                            <div class="col-7 text-left">
                                <h6 class="des-h1"> {{item.name}}</h6>
                                <div class="desc-channel-name">{{item.description}}</div>
                            </div>
                            <div class="col-5 text-right">
                                <div class="b-con">
                                    <div class="buy-now mb-2 fw-800" *ngIf="item.number_of_copies_for_sale
                                        > 0 && item.saleType != 'auction'">
                                        Buy Now
                                    </div>
                                    <div class="buy-now mb-2 fw-800" *ngIf="item.number_of_copies_for_sale
                                        > 0 && item.saleType == 'auction'">
                                        Make Bid
                                    </div>
                                    <div class="sold-out mb-2 fw-bold" *ngIf="item.number_of_copies_for_sale
                                        == 0">
                                        Sold Out
                                    </div>
                                    <div class="token" *ngIf="item.number_of_copies_for_sale
                                        > 0">
                                        <span class="img align-middle"><img src="{{cryptoSymbol}}" class="mb-1"
                                                width="18"> </span> <span class="align-middle amount ml-1">
                                            {{item.salePrice | number: '1.2-2'}} </span> <span>{{item.token_type ==='GFL' ? item.token_type : clientDetailsName ==='BigbeeAI' ? 'BB' :cryptoToken}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </ng-container>
        </div>
        <div *ngIf="nftList?.length == 0">
            <div class="d-flex justify-content-center mb-25">NO DATA AVAILABLE</div>
        </div>
    </section>
</div>